import { ForgotPasswordForm } from "@/features/auth/components/forgot-password-form";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/zapomenute-heslo")({
  component: ForgotPasswordPage,
});

function ForgotPasswordPage() {
  return (
    <div
      data-testid="auth-forgot-page"
      className="flex min-h-screen items-center justify-center bg-background p-4"
    >
      <ForgotPasswordForm />
    </div>
  );
}
